module.exports = require("@swa-ui/core/src/ListMatrix/ListMatrix.module.scss");